import { DOCUMENT } from '@angular/common';
import { inject, Injectable } from '@angular/core';

export type OidcProviderName = 'google' | 'eventival';

@Injectable({
  providedIn: 'root',
})
export class SsoAuthService {
  private readonly document = inject(DOCUMENT);

  loginWithOidc(provider: OidcProviderName, redirectUrl: string | null = null): void {
    const redirectQuery = redirectUrl !== null
      ? `?redirect=${encodeURIComponent(redirectUrl)}`
      : '';

    this.document.location.href = `/rest/users/auth/${provider}${redirectQuery}`;
  }
}
